import { valueDataToString } from "@smartsuite/automation-conditions";
import type { RecordJobData } from "@smartsuite/automation-engine-api";
import type { PdfInfo } from "./types";

export const extractPdfInfo = (recordJobData?: RecordJobData): PdfInfo => {
  const titleOutput = recordJobData?.outputData?.outputs.find(
    (output) => output.outputId === "exported-pdf-title",
  );

  const linkOutput = recordJobData?.outputData?.outputs.find(
    (output) => output.outputId === "exported-pdf-url",
  );

  const title = titleOutput
    ? valueDataToString(titleOutput.value)
    : "<no value>";

  let link: string | undefined;
  if (linkOutput !== undefined) {
    link = valueDataToString(linkOutput.value);
  }

  return { title, link };
};
